import React, { useState } from "react";
import { useAuth } from "../../components/Auth/AuthProvider";
import { useTheme } from "../../App";
import styles from "./OnboardingUseCase.module.css";
import diffusionIconLight from "../../assets/diffusion_light.svg";
import diffusionIconDark from "../../assets/diffusion_dark.svg";

const useCaseOptions = [
  "Learning CAD",
  "Work",
  "Personal project(s)",
  "School",
  "Something else",
];

const OnboardingUseCase: React.FC = () => {
  const { updateUserProfile } = useAuth();
  const { theme, setTheme } = useTheme();
  const getActualTheme = (): "light" | "dark" => {
    if (theme === "system") {
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    return theme as "light" | "dark";
  };
  const actualTheme = getActualTheme();
  const [selectedUseCase, setSelectedUseCase] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const diffusionIcon =
    actualTheme === "dark" ? diffusionIconDark : diffusionIconLight;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedUseCase || loading) return;

    setLoading(true);

    try {
      await updateUserProfile({
        useCase: selectedUseCase,
      });

      window.history.pushState({}, "", "/onboarding/role");
      window.dispatchEvent(new PopStateEvent("popstate"));
    } catch (error) {
      // console.error("Error saving use case:", error);
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button
          className={styles.logoButton}
          onClick={() => (window.location.href = "/")}
          aria-label="Go to home"
        >
          <img src={diffusionIcon} alt="Noah" className={styles.logo} />
        </button>
      </div>

      <div className={styles.scrollableContent}>
        <div className={styles.content}>
          <h1 className={styles.title}>How will you use Noah?</h1>
          <p className={styles.description}>
            If you'll use Noah for a few reasons, pick the main one.
          </p>

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.optionsContainer}>
              {useCaseOptions.map((option) => (
                <button
                  key={option}
                  type="button"
                  onClick={() => setSelectedUseCase(option)}
                  className={`${styles.optionButton} ${
                    selectedUseCase === option
                      ? styles.optionButtonSelected
                      : ""
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>

            <div className={styles.buttonContainer}>
              <button
                type="submit"
                disabled={!selectedUseCase || loading}
                className={styles.submitButton}
              >
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OnboardingUseCase;
